import React, { ReactNode, createContext, useContext } from "react";
import { useComplexState } from "use-complex-state";
import { PartsReducer } from "../reducers/PartsReducer";

const PartsContext = createContext({
	state: PartsReducer.getInitialState(),
	actions: PartsReducer.actions,
});

export const usePartsContext = () => useContext(PartsContext);

export const PartsProvider = ({ children }: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: PartsReducer.getInitialState(),
		reducers: PartsReducer.caseReducers,
	});

	return (
		<PartsContext.Provider value={{ state, actions }}>
			{children}
		</PartsContext.Provider>
	);
};
